export default __webpack_public_path__ + "static/media/State_emblem_of_Pakistan.svg1.ccc58c1b.svg";